import { combineReducers } from 'redux';
import { Reducer } from "../../../types";
import {
  setOptionSendEmail,
  setOptionRequestBilling,
  setOptionRequestRegistration,
  setOptionSender,
} from "../actions";
import { UserPermissionsAction } from "../types";

export type State = {
  invite: boolean;
  cc_sender: boolean;
  request_registration: boolean;
  request_billing_info: boolean;
};

type ReducerOf<T extends keyof State> = Reducer<State, UserPermissionsAction, T>;

const invite: ReducerOf<'invite'> = (state = true, action) => {
  switch (action.type) {
    case setOptionSendEmail.type:
      return action.payload;

    default:
      return state;
  }
};

const cc_sender: ReducerOf<'cc_sender'> = (state = false, action) => {
  switch (action.type) {
    case setOptionSender.type:
      return action.payload;

    default:
      return state;
  }
};

const request_registration: ReducerOf<'request_registration'> = (state = true, action) => {
  switch (action.type) {
    case setOptionRequestRegistration.type:
      return action.payload;

    default:
      return state;
  }
};

const request_billing_info: ReducerOf<'request_billing_info'> = (state = true, action) => {
  switch (action.type) {
    case setOptionRequestBilling.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<State>({
  invite,
  cc_sender,
  request_registration,
  request_billing_info
});
